import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from "enumify-ts";
class MarketplaceConsignmentPaymentMethod extends Enumify() {
    shortDescription;
    fullDescription;
    help;
    static TONNE = new MarketplaceConsignmentPaymentMethod("Tonne", "Pay by the Tonne", () => {
        return (_jsxs("div", { className: "popover-help-lg", children: [_jsx("h3", { children: "PAY BY THE TONNE" }), _jsxs("p", { children: ["An ideal way for paying exactly on the Tonne delivered. Pay by the tonne is based on the following metrics", _jsx("br", {}), "Example:", _jsx("br", {}), "Load Rate $100", _jsx("br", {}), "Vehicle Type - Tipper Tandem", _jsx("br", {}), "Average Carrying Capacity - 12 Tonne (Set by SubTrux)", _jsx("br", {}), "Tonnage Rate - $8.33 ($100/12)", _jsx("br", {}), "Estimated Load rate displayed will depend on the Tonne amount entered", _jsx("br", {}), "This rate is then multiplied by the actual Tonne Delivered", _jsx("br", {}), "\u00A0", _jsx("br", {}), "Example:", _jsx("br", {}), "Tonne Delivered 11.68", _jsx("br", {}), "Actual total for the delivery $97.29 (11.68 x $8.33)", _jsx("br", {}), "\u00A0", _jsx("br", {}), "Note: The Tonne delivered may vary between different deliveries and vehicles."] })] }));
    });
    static DELIVERY = new MarketplaceConsignmentPaymentMethod("Delivery", "Pay by the Delivery", () => {
        return (_jsxs("div", { className: "popover-help-lg", children: [_jsx("h3", { children: "PAY BY THE DELIVERY" }), _jsxs("p", { children: ["An ideal way of knowing what the exact rate will be for the delivery without any surprises.", _jsx("br", {}), "\u00A0", _jsx("br", {}), "Note: The Tonne delivered may vary between different deliveries and vehicles."] })] }));
    });
    static _ = MarketplaceConsignmentPaymentMethod._closeEnum();
    constructor(shortDescription, fullDescription, help) {
        super();
        this.shortDescription = shortDescription;
        this.fullDescription = fullDescription;
        this.help = help;
    }
    renderTag() {
        return _jsx(Tag, { children: this.shortDescription });
    }
    renderFullTag() {
        return _jsx(Tag, { children: this.fullDescription });
    }
    static filtersArray() {
        return MarketplaceConsignmentPaymentMethod.values
            .map(t => {
            return { text: t.shortDescription, value: t.key };
        });
    }
}
export default MarketplaceConsignmentPaymentMethod;
